import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppConfig } from "../Configs/AppConfig";
import {
  acquireMqttLiveSocket,
  getMqttLiveSocket,
  releaseMqttLiveSocket,
} from "./mqttLiveSocket";
import { LIDAR_TELEMETRY_LIVE_EVENT } from "./useDeviceLidarTelemetry";
import { SENSOR_TELEMETRY_LIVE_EVENT } from "./useDeviceSensorTelemetry";
import {
  updateLidarTelemetryLive,
  updateSensorTelemetryLive,
} from "../Store/Slices/telemetryLiveSlice";

/**
 * Single app-wide telemetry WebSocket listener — patches confirmed WL and rain per location.
 * Mount once inside the authenticated layout.
 */
export default function useLidarTelemetryLiveBridge() {
  const dispatch = useDispatch();

  useEffect(() => {
    const url = AppConfig.SOCKET_URL;
    if (!url) return undefined;

    const onLidarLive = (payload) => {
      if (!payload?.locationId) return;
      dispatch(updateLidarTelemetryLive(payload));
    };

    const onSensorLive = (payload) => {
      if (!payload?.locationId) return;
      dispatch(updateSensorTelemetryLive(payload));
    };

    acquireMqttLiveSocket(url);
    const socket = getMqttLiveSocket();
    socket?.on(LIDAR_TELEMETRY_LIVE_EVENT, onLidarLive);
    socket?.on(SENSOR_TELEMETRY_LIVE_EVENT, onSensorLive);

    return () => {
      getMqttLiveSocket()?.off(LIDAR_TELEMETRY_LIVE_EVENT, onLidarLive);
      getMqttLiveSocket()?.off(SENSOR_TELEMETRY_LIVE_EVENT, onSensorLive);
      releaseMqttLiveSocket();
    };
  }, [dispatch]);
}
